/*
  Header behaviour: compact-on-scroll, hover mega panels, mobile panel.

  Kept separate from the reveal layer because the header must stay responsive
  even when motion is reduced -- the compact state is a layout change, not
  decoration, and the panels are navigation.
*/
(function () {
  var SCROLL_THRESHOLD = 30;
  var DESKTOP_MIN_WIDTH = 880;

  var wrapper = document.querySelector('[data-lr-header]');
  if (!wrapper) return;

  /* Compact state ------------------------------------------------------- */

  var pending = false;
  function syncScrollState() {
    var scrolled = window.scrollY > SCROLL_THRESHOLD;
    wrapper.classList.toggle('lr-header--scrolled', scrolled);
    /* Published on <html> too: the header wrapper is not an ancestor of the
       collection page's sticky filter bar, which still needs to know the
       header's rendered height to pin itself right underneath it. */
    document.documentElement.classList.toggle('lr-header-scrolled', scrolled);
    pending = false;
  }
  window.addEventListener(
    'scroll',
    function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(syncScrollState);
    },
    { passive: true }
  );

  /* A backgrounded tab stops serving requestAnimationFrame, so a frame queued on
     the way out never runs and `pending` stays true forever -- from then on every
     scroll returns early and the header never compacts again. Coming back into
     view clears the stuck flag and resyncs against the real scroll position. */
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) return;
    pending = false;
    syncScrollState();
  });

  syncScrollState();

  /* Mega panels --------------------------------------------------------- */

  var items = Array.prototype.slice.call(wrapper.querySelectorAll('[data-lr-nav-item]'));

  function syncMenuState() {
    /* An open panel grounds the bar: over a dark hero the strip above an
       opaque panel would otherwise read as a seam. */
    wrapper.classList.toggle(
      'lr-header--menu-open',
      !!wrapper.querySelector('.lr-header__mega--open, .lr-header__mobile--open')
    );
  }

  function closePanels() {
    items.forEach(function (item) {
      item.classList.remove('lr-header__item--open');
      var panel = panelFor(item);
      if (panel) {
        panel.classList.remove('lr-header__mega--open');
        item.querySelector('.lr-header__link').setAttribute('aria-expanded', 'false');
      }
    });
    syncMenuState();
  }

  function panelFor(item) {
    return wrapper.querySelector('#' + item.dataset.lrNavItem);
  }

  items.forEach(function (item) {
    var panel = panelFor(item);
    if (!panel) return;
    var trigger = item.querySelector('.lr-header__link');

    function open() {
      closePanels();
      item.classList.add('lr-header__item--open');
      panel.classList.add('lr-header__mega--open');
      trigger.setAttribute('aria-expanded', 'true');
      syncMenuState();
    }

    item.addEventListener('mouseenter', open);
    // Keyboard users never fire mouseenter, so the panel opens on focus too.
    trigger.addEventListener('focus', open);
  });

  wrapper.addEventListener('mouseleave', closePanels);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closePanels();
  });
  // Focus leaving the header entirely closes whatever is open.
  wrapper.addEventListener('focusout', function (event) {
    if (!wrapper.contains(event.relatedTarget)) closePanels();
  });

  /* Mobile panel -------------------------------------------------------- */

  var toggle = wrapper.querySelector('[data-lr-header-toggle]');
  var mobile = wrapper.querySelector('[data-lr-header-mobile]');

  if (toggle && mobile) {
    toggle.addEventListener('click', function () {
      var open = mobile.classList.toggle('lr-header__mobile--open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.textContent = open ? toggle.dataset.labelClose : toggle.dataset.labelOpen;
      syncMenuState();
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth >= DESKTOP_MIN_WIDTH && mobile.classList.contains('lr-header__mobile--open')) {
        mobile.classList.remove('lr-header__mobile--open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.textContent = toggle.dataset.labelOpen;
        syncMenuState();
      }
    });
  }

  /* Cart count ---------------------------------------------------------- */

  /* The count lives inside #cart-icon-bubble, whose subtree Dawn replaces
     wholesale through the Section Rendering API after every add. Two things
     have to be reapplied on the far side of that swap, so both hang off a
     MutationObserver rather than off any one add-to-cart code path:

     1. Dawn's section omits the bubble entirely for an empty cart. This design
        always shows one, so a missing bubble is rebuilt as a zero.
     2. The pop only reads as feedback if it replays. Restarting the animation
        needs the class off, a reflow, and the class back on -- assigning the
        same animation to an element that already has it is a no-op. */

  var cartLink = wrapper.querySelector('#cart-icon-bubble');

  if (cartLink) {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var lastCount = null;

    function bubble() {
      var node = cartLink.querySelector('.cart-count-bubble');
      if (!node) {
        node = document.createElement('div');
        node.className = 'cart-count-bubble';
        node.innerHTML = '<span aria-hidden="true">0</span>';
        cartLink.appendChild(node);
      }
      return node;
    }

    function countOf(node) {
      var visible = node.querySelector('[aria-hidden="true"]');
      return visible ? visible.textContent.trim() : '';
    }

    function syncCart() {
      var node = bubble();
      var count = countOf(node);
      if (lastCount !== null && count !== lastCount && !reduced.matches) {
        node.classList.remove('lr-pop');
        void node.offsetWidth; // forces the restart
        node.classList.add('lr-pop');
      }
      lastCount = count;
    }

    new MutationObserver(syncCart).observe(cartLink, { childList: true, subtree: true });
    syncCart();
  }
})();
